<template>
  <div>
    <div v-if="alteracoes.length" class="detail-table-wrap">
      <table class="detail-table alt-table">
        <colgroup>
          <col class="col-chevron" />
          <col class="col-voucher" />
          <col class="col-cliente" />
          <col class="col-chegada" />
          <col class="col-resumo" />
          <col class="col-visto" />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th>Voucher / Reserva</th>
            <th>Cliente</th>
            <th>Chegada</th>
            <th>{{ tipo === "editada" ? "O que mudou" : "Situação" }}</th>
            <th>Visto em</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="i in alteracoes">
            <tr
              :key="chave(i)"
              class="import-row"
              :class="{ 'is-open': openId === chave(i) }"
              @click="toggle(chave(i))"
            >
              <td class="chevron-cell">
                <v-icon
                  size="18"
                  class="chevron"
                  :class="{ 'is-open': openId === chave(i) }"
                  >mdi-chevron-right</v-icon
                >
              </td>
              <td class="voucher-cell">
                {{ i.localizador }}
              </td>
              <td>{{ i.cliente || "—" }}</td>
              <td class="muted">
                {{ i.chegada ? dataCurta(i.chegada) : "—" }}
              </td>
              <td>
                <span
                  class="rate-pill"
                  :class="
                    tipo === 'editada' ? 'rate-pill--warn' : pillClassCancelada(i)
                  "
                  >{{ resumoLinha(i) }}</span
                >
              </td>
              <td class="muted">{{ dataCurta(i.ultima_vez) }}</td>
            </tr>
            <tr
              v-if="openId === chave(i)"
              :key="chave(i) + '-det'"
              class="import-detail-row"
            >
              <td colspan="6">
                <div class="alt-panel">
                  <template v-if="tipo === 'cancelada'">
                    <p
                      v-if="statusPhoenixCancelada(i) === 'ativa'"
                      class="alt-note alt-note--bad"
                    >
                      Esta reserva consta como <b>cancelada</b> na planilha da
                      Azul, mas <b>ainda está ATIVA no Phoenix</b>
                      <template v-if="codigosAtivos(i).length">
                        (código{{ codigosAtivos(i).length > 1 ? "s" : "" }}:
                        <b>{{ codigosAtivos(i).join(", ") }}</b
                        >)</template
                      >. <b>Alguém precisa cancelá-la manualmente.</b>
                    </p>
                    <p
                      v-else-if="statusPhoenixCancelada(i) === 'ja_cancelada'"
                      class="alt-note alt-note--ok"
                    >
                      Esta reserva consta como <b>cancelada</b> na planilha da
                      Azul — e já está <b>cancelada no Phoenix também</b>.
                      Nada a fazer.
                    </p>
                    <p
                      v-else-if="statusPhoenixCancelada(i) === 'nao_existe'"
                      class="alt-note alt-note--ok"
                    >
                      Esta reserva consta como <b>cancelada</b> na planilha da
                      Azul.
                      <template v-if="i.naoImportada"
                        ><b>Não foi importada no Phoenix</b> (o agente a
                        retirou do lote).</template
                      >
                      <template v-else
                        ><b>Não existe no Phoenix</b> para este voucher.</template
                      >
                      Nada a fazer.
                    </p>
                    <p v-else class="alt-note">
                      Esta reserva consta como <b>cancelada</b> na planilha da
                      Azul. Não foi possível confirmar o status no Phoenix{{
                        i.phoenixErro ? ` (${i.phoenixErro})` : ""
                      }}
                      — confira manualmente.
                    </p>
                  </template>

                  <template v-else>
                    <div class="alt-summary">
                      <span v-if="diffs(i).length" class="alt-summary-n">
                        {{ diffs(i).length }}
                        {{ diffs(i).length > 1 ? "campos" : "campo" }} a alterar
                        no Phoenix
                      </span>
                      <span v-else class="alt-summary-ok">
                        Nenhuma diferença encontrada entre o Phoenix e a planilha
                      </span>
                      <a
                        v-if="iguais(i).length"
                        class="alt-toggle"
                        @click.stop="toggleIguais(chave(i))"
                      >
                        {{
                          mostrarIguais[chave(i)]
                            ? "ocultar campos iguais"
                            : `mostrar ${iguais(i).length} campo(s) igual(is)`
                        }}
                      </a>
                    </div>
                    <p v-if="i.phoenixErro" class="alt-note">
                      Não foi possível ler o Phoenix ({{ i.phoenixErro }}).
                    </p>
                    <table class="alt-cmp">
                      <thead>
                        <tr>
                          <th>Campo</th>
                          <th class="alt-cmp-phx">
                            <v-icon size="15" color="#fff"
                              >mdi-database-outline</v-icon
                            >
                            Como está no Phoenix (antes)
                          </th>
                          <th class="alt-cmp-cvc">
                            <v-icon size="15" color="#fff">mdi-pencil</v-icon>
                            Como deve ficar (planilha)
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(r, k) in linhasVisiveis(i)">
                          <tr v-if="r.secao" :key="'s' + k" class="alt-cmp-sec">
                            <td colspan="3">{{ r.secao }}</td>
                          </tr>
                          <tr :key="'r' + k" :class="{ 'is-diff': r.diff }">
                            <td class="alt-cmp-label">
                              {{ r.label }}
                              <span v-if="r.diff" class="alt-tag">alterar</span>
                            </td>
                            <td class="alt-cmp-a" :class="{ 'is-empty': !r.a }">
                              {{ r.a || "(em branco)" }}
                            </td>
                            <td class="alt-cmp-b" :class="{ 'is-empty': !r.b }">
                              {{ r.b || "(em branco)" }}
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </template>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tfoot v-if="meta.listadas < meta.total">
          <tr>
            <td colspan="6">
              Listando {{ meta.listadas }} de {{ meta.total }} no período.
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div v-else class="detail-empty detail-empty--ok">
      <v-icon size="18" color="#0f7a6e">mdi-check-circle-outline</v-icon>
      {{
        tipo === "editada"
          ? "Nenhuma reserva editada na planilha no período."
          : "Nenhuma reserva cancelada na planilha no período."
      }}
    </div>
  </div>
</template>

<script>
const dataBR = (s) => {
  const m = String(s || "").match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}:\d{2}))?/
  );
  if (!m) return String(s || "");
  return `${m[3]}/${m[2]}/${m[1]}${m[4] && m[4] !== "00:00" ? " " + m[4] : ""}`;
};

// common/models/Reserve.php — unico status que significa "nao esta mais
// ativa" no Phoenix. Qualquer outro valor (rascunho, nao subiu, subiu, em
// execucao, finalizada, solicitada) e' uma reserva de verdade que alguem
// precisa ir cancelar manualmente se a planilha marcou como cancelada.
const RESERVE_STATUS_CANCELED = 2;

export default {
  name: "PlanilhaAlteracoes",
  props: {
    alteracoes: { type: Array, default: () => [] },
    meta: { type: Object, default: () => ({ total: 0, listadas: 0 }) },
    tipo: { type: String, required: true }, // 'cancelada' | 'editada'
  },
  data() {
    return { openId: null, mostrarIguais: {} };
  },
  methods: {
    toggleIguais(id) {
      this.$set(this.mostrarIguais, id, !this.mostrarIguais[id]);
    },
    diffs(i) {
      return this.comparacao(i).filter((r) => r.diff);
    },
    iguais(i) {
      return this.comparacao(i).filter((r) => !r.diff);
    },
    // Linhas a mostrar: as que mudam; as iguais so quando pedido. O titulo de
    // secao vai na primeira linha visivel de cada secao.
    linhasVisiveis(i) {
      const todas = this.comparacao(i);
      let secao = null;
      const out = [];
      let ultimaSecaoMostrada = null;
      for (const r of todas) {
        if (r.secao) secao = r.secao;
        if (!r.diff && !this.mostrarIguais[this.chave(i)]) continue;
        out.push({
          ...r,
          secao: secao !== ultimaSecaoMostrada ? secao : null,
        });
        ultimaSecaoMostrada = secao;
      }
      return out;
    },
    toggle(id) {
      this.openId = this.openId === id ? null : id;
    },
    chave(i) {
      return String(i.localizador || i.id || "");
    },
    dataCurta: dataBR,
    // Classifica o que sabemos do Phoenix pra uma reserva cancelada na planilha
    // da Azul: 'ativa' = alguem precisa ir cancelar na mao; 'ja_cancelada' /
    // 'nao_existe' = nada a fazer; 'desconhecido' = a checagem do agente
    // falhou (login/HTTP), nao da pra afirmar nada.
    statusPhoenixCancelada(i) {
      if (i.phoenixErro === "nao_encontrada_no_phoenix") return "nao_existe";
      const reservas = this.phoenixReservas(i);
      if (reservas.length) {
        return reservas.some((r) => r.status !== RESERVE_STATUS_CANCELED)
          ? "ativa"
          : "ja_cancelada";
      }
      return "desconhecido";
    },
    codigosAtivos(i) {
      return this.phoenixReservas(i)
        .filter((r) => r.status !== RESERVE_STATUS_CANCELED)
        .map((r) => r.code)
        .filter(Boolean);
    },
    pillClassCancelada(i) {
      const s = this.statusPhoenixCancelada(i);
      if (s === "ativa") return "rate-pill--bad";
      if (s === "desconhecido") return "rate-pill--warn";
      return "rate-pill--ok";
    },
    resumoLinha(i) {
      if (this.tipo === "cancelada") {
        const s = this.statusPhoenixCancelada(i);
        if (s === "ativa") return "Ainda ativa no Phoenix — cancelar";
        if (s === "ja_cancelada") return "Já cancelada no Phoenix";
        if (s === "nao_existe") return "Não existe no Phoenix";
        return "Não verificado";
      }
      const n = i.mudancas.length;
      if (n) return `${n} alteraç${n > 1 ? "ões" : "ão"}`;
      return "Editada na planilha";
    },
    comparacao(i) {
      const campos = Array.isArray(i.campos) && i.campos.length ? i.campos : (i.mudancas || []).map((m) => ({ secao: m.secao, campo: m.campo, phoenix: m.de, planilha: m.para, igual: false }));
      return campos.map((c) => ({ secao: c.secao, label: c.campo, a: c.phoenix || "", b: c.planilha || "", diff: !c.igual }));
    },
    phoenixReservas(i) {
      return (i.phoenix && i.phoenix.reserves) || [];
    },
  },
};
</script>

<style scoped lang="scss">
@import "../_shared/detail.scss";

.alt-table {
  table-layout: fixed;
  width: 100%;
  min-width: 860px;

  col.col-chevron {
    width: 40px;
  }
  col.col-voucher {
    width: 22%;
  }
  col.col-cliente {
    width: 22%;
  }
  col.col-chegada {
    width: 14%;
  }
  col.col-resumo {
    width: 22%;
  }
  col.col-visto {
    width: 20%;
  }

  th,
  td {
    white-space: normal;
    vertical-align: top;
    word-break: break-word;
  }

  .voucher-cell {
    font-weight: 700;
    color: #384049;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
  }
}

.import-row {
  cursor: pointer;
  &:hover td {
    background: #f3f6f7;
  }
  &.is-open td {
    background: #f4f9f8 !important;
  }
}
.chevron-cell {
  padding-right: 0;
  padding-left: 12px;
}
.chevron {
  transition: transform 0.15s ease;
  color: #9aa2ab;
  &.is-open {
    transform: rotate(90deg);
    color: #0f7a6e;
  }
}
.import-detail-row td {
  padding: 10px 14px 16px 48px;
  background: #f4f9f8;
}

.alt-panel {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.alt-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.alt-chip {
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 20px;
  padding: 3px 11px;
  font-size: 0.76rem;
  color: #4a535c;
}
.alt-block-title {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b747d;
  margin-top: 4px;
}
.alt-note {
  font-size: 0.82rem;
  color: #4a535c;
  margin: 0;
  background: #fff;
  border: 1px dashed #d6dbe0;
  border-radius: 8px;
  padding: 9px 12px;
  &--bad {
    border-color: #f0b8b8;
    background: #fdf3f3;
    color: #8a2a2a;
  }
  &--ok {
    border-color: #cdeae4;
    background: #eefaf7;
    color: #0f7a6e;
  }
}
.alt-diff {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 8px;
  font-size: 0.8rem;
  th,
  td {
    padding: 7px 10px;
    text-align: left;
    vertical-align: top;
    white-space: normal;
  }
  thead th {
    font-size: 0.7rem;
    text-transform: uppercase;
    color: #6b747d;
    background: #f7f9fa;
  }
  tbody tr + tr td {
    border-top: 1px solid #eef0f2;
  }
}
.alt-old {
  color: #a23a3a;
  background: #fdf3f3;
  text-decoration: line-through;
  text-decoration-color: #e2b0b0;
}
.alt-new {
  color: #17603b;
  background: #eef8f1;
  font-weight: 600;
}

.alt-cmp {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 10px;
  overflow: hidden;
  font-size: 0.8rem;
  th {
    padding: 8px 12px;
    text-align: left;
    color: #fff;
    font-size: 0.78rem;
    width: 38%;
  }
  th:first-child {
    width: 24%;
    background: #f7f9fa;
  }
  .alt-cmp-phx {
    background: #0f7a6e;
  }
  .alt-cmp-cvc {
    background: #2f5fa7;
  }
  td {
    padding: 7px 12px;
    vertical-align: top;
    border-top: 1px solid #eef0f2;
    color: #2b333b;
    word-break: break-word;
  }
  .alt-cmp-label {
    color: #6b747d;
    font-size: 0.76rem;
  }
  .alt-cmp-sec td {
    background: #f7f9fa;
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #8a939c;
    padding: 5px 12px;
  }
  tr.is-diff td.alt-cmp-a {
    background: #fdf3f3;
    color: #a23a3a;
    text-decoration: line-through;
    text-decoration-color: #e2b0b0;
  }
  tr.is-diff td.alt-cmp-b {
    background: #eef8f1;
    color: #17603b;
    font-weight: 700;
  }
  tr.is-diff td.is-empty {
    text-decoration: none;
  }
  td.is-empty {
    color: #b3bac1;
    font-weight: 400 !important;
  }
}
.alt-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 0.82rem;
}
.alt-summary-n {
  background: #fff6dc;
  border: 1px solid #f0d58a;
  color: #7a5a00;
  font-weight: 700;
  border-radius: 20px;
  padding: 3px 12px;
}
.alt-summary-ok {
  color: #17603b;
  font-weight: 600;
}
.alt-toggle {
  color: #2f5fa7;
  cursor: pointer;
  font-size: 0.78rem;
  text-decoration: underline;
}
.alt-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 0 7px;
  border-radius: 10px;
  background: #f0b429;
  color: #3d2c00;
  font-size: 0.62rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.alt-compare {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.alt-col {
  background: #fff;
  border: 1px solid #e6e9ec;
  border-radius: 10px;
  padding: 0 0 10px;
  overflow: hidden;
}
.alt-col-head {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  padding: 8px 12px;
  color: #fff;
  &--phx {
    background: #0f7a6e;
  }
  &--cvc {
    background: #2f5fa7;
  }
}
.alt-sec {
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #8a939c;
  padding: 10px 12px 3px;
}
.alt-list {
  list-style: none;
  margin: 0;
  padding: 0 12px;
  font-size: 0.8rem;
  color: #384049;
  li {
    padding: 2px 0;
  }
  li.is-diff {
    background: #fff6dc;
    border-left: 3px solid #f0b429;
    padding-left: 7px;
    font-weight: 600;
  }
}
.alt-item {
  font-size: 0.72rem;
}
.alt-svc {
  display: flex;
  flex-direction: column;
  padding: 6px 0 !important;
  border-bottom: 1px solid #eef0f2;
  b {
    font-weight: 700;
    color: #2b333b;
  }
  span {
    font-size: 0.76rem;
    color: #6b747d;
  }
  &:last-child {
    border-bottom: 0;
  }
}
.alt-foot {
  font-size: 0.72rem;
  color: #8a939c;
  margin: 0;
}

@media (max-width: 900px) {
  .alt-compare {
    grid-template-columns: 1fr;
  }
}
</style>
